import './Styles/ScrollUpArrowStyles.css'

import { useState, useEffect } from 'react'
import { FaArrowAltCircleUp, FaArrowAltCircleDown } from "react-icons/fa"
import { useParams } from '../../Providers/ParamsProvider'

/**
 * DK : Komponent przewijania góra - dół 
 * @param {*} color - kolor strzałek, domyślnie 'var(--primary)'
 * @returns 
 */
const ScrollUpArrow = ({ color = 'var(--primary)', getScrollElement = null }) => {
    const { isMobile } = useParams()
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        // getScrollElement (opcjonalny) - kiedy treść przewija się w kontenerze
        // wewnętrznym (np. wirtualny grid), a nie w oknie
        const el = getScrollElement ? getScrollElement() : null
        const target = el || window

        const handleScroll = () => {
            const scrollTop = el
                ? el.scrollTop
                : window.pageYOffset || document.documentElement.scrollTop
            setIsVisible(scrollTop > 300)
        }

        target.addEventListener('scroll', handleScroll)
        handleScroll()
        return () => target.removeEventListener('scroll', handleScroll)
    }, [getScrollElement])

    const scrollToTop = () => {
        const el = getScrollElement ? getScrollElement() : null
        ;(el || window).scrollTo({ top: 0, behavior: 'smooth' })
    }

    const scrollToBottom = () => {
        const el = getScrollElement ? getScrollElement() : null
        if (el) {
            el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' })
        } else {
            window.scrollTo({
                top: document.documentElement.scrollHeight,
                behavior: 'smooth',
            })
        }
    }

    let arrowType = isMobile ? 'scroll-up-arrow-mobile' : 'scroll-up-arrow'
    let arrowStyle = isVisible ? `${arrowType}` : 'collapse'
    let colorStyle = color

    return (
        <div className={`${arrowStyle} `}>
            <FaArrowAltCircleUp
                size={isMobile ? 35 : 45}
                onClick={() => scrollToTop()}
                color={colorStyle}
            />
            <FaArrowAltCircleDown
                className={isMobile ? 'mt-1' : 'mt-3'}
                size={isMobile ? 35 : 45}
                onClick={() => scrollToBottom()}
                color={colorStyle}
            />
        </div>
    )
}

export default ScrollUpArrow